import { useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setRefreshFn } from '../actions/refreshActions';

const useSetRefreshFn = (fn, deps) => {
  const dispatch = useDispatch();

  const memoizedFn = useCallback(fn, deps);

  useEffect(() => {
    dispatch(setRefreshFn(memoizedFn));
  }, [memoizedFn]);
};

export default useSetRefreshFn;
